class DisclosureNav {
  constructor(domNode) {
    this.rootNode = domNode
    this.controlledNodes = []
    this.openIndex = null
    this.useArrowKeys = true
    this.topLevelNodes = [...this.rootNode.querySelectorAll('button[aria-expanded][aria-controls]')]

    this.topLevelNodes.forEach((node) => {
      // handle button + menu
      if (node.tagName.toLowerCase() === 'button' && node.hasAttribute('aria-controls')) {
        const menu = node.parentNode.querySelector('ul')
        if (menu) {
          // save ref controlled menu
          this.controlledNodes.push(menu)

          // collapse menus
          node.setAttribute('aria-expanded', 'false')
          this.toggleMenu(menu, false)

          // attach event listeners
          menu.addEventListener('keydown', this.onMenuKeyDown.bind(this))
          node.addEventListener('click', this.onButtonClick.bind(this))
          node.addEventListener('keydown', this.onButtonKeyDown.bind(this))
        }
      }
      // handle links
      else {
        this.controlledNodes.push(null)
        node.addEventListener('keydown', this.onLinkKeyDown.bind(this))
      }
    })

    this.rootNode.addEventListener('focusout', this.onBlur.bind(this))
  }

  controlFocusByKey(keyboardEvent, nodeList, currentIndex) {
    switch (keyboardEvent.key) {
      case 'ArrowUp':
      case 'ArrowLeft':
        keyboardEvent.preventDefault()
        if (currentIndex > -1) {
          const prevIndex = Math.max(0, currentIndex - 1)
          nodeList[prevIndex].focus()
        }
        break
      case 'ArrowDown':
      case 'ArrowRight':
        keyboardEvent.preventDefault()
        if (currentIndex > -1) {
          const nextIndex = Math.min(nodeList.length - 1, currentIndex + 1)
          nodeList[nextIndex].focus()
        }
        break
      case 'Home':
        keyboardEvent.preventDefault()
        nodeList[0].focus()
        break
      case 'End':
        keyboardEvent.preventDefault()
        nodeList[nodeList.length - 1].focus()
        break
    }
  }

  // public function to close open menu
  close() {
    this.toggleExpand(this.openIndex, false)
  }

  onBlur(event) {
    const menuContainsFocus = this.rootNode.contains(event.relatedTarget)
    if (!menuContainsFocus && this.openIndex !== null) {
      this.toggleExpand(this.openIndex, false)
    }
  }

  onButtonClick(event) {
    const button = event.target.closest('button')
    const buttonIndex = this.topLevelNodes.indexOf(button)
    const buttonExpanded = button.getAttribute('aria-expanded') === 'true'
    this.toggleExpand(buttonIndex, !buttonExpanded)
  }

  onButtonKeyDown(event) {
    const targetButtonIndex = this.topLevelNodes.indexOf(document.activeElement)

    // close on escape
    if (event.key === 'Escape') {
      this.toggleExpand(this.openIndex, false)
    }

    // move focus into the open menu if the current menu is open
    else if (this.useArrowKeys && this.openIndex === targetButtonIndex && event.key === 'ArrowDown') {
      event.preventDefault()
      this.controlledNodes[this.openIndex].querySelector('a').focus()
    }

    // handle arrow key navigation between top-level buttons, if set
    else if (this.useArrowKeys) {
      this.controlFocusByKey(event, this.topLevelNodes, targetButtonIndex)
    }
  }

  onLinkKeyDown(event) {
    const targetLinkIndex = this.topLevelNodes.indexOf(document.activeElement)

    // handle arrow key navigation between top-level buttons, if set
    if (this.useArrowKeys) {
      this.controlFocusByKey(event, this.topLevelNodes, targetLinkIndex)
    }
  }

  onMenuKeyDown(event) {
    if (this.openIndex === null) {
      return
    }

    const menuLinks = Array.prototype.slice.call(this.controlledNodes[this.openIndex].querySelectorAll('a'))
    const currentIndex = menuLinks.indexOf(document.activeElement)

    // close on escape
    if (event.key === 'Escape') {
      this.topLevelNodes[this.openIndex].focus()
      this.toggleExpand(this.openIndex, false)
    }

    // handle arrow key navigation within menu links, if set
    else if (this.useArrowKeys) {
      this.controlFocusByKey(event, menuLinks, currentIndex)
    }
  }

  toggleExpand(index, expanded) {
    console.log('toggleExpand index, expanded', index, expanded)
    console.log(this.controlledNodes)
    console.log(this.openIndex)
    // close open menu, if applicable
    if (this.openIndex !== null && this.openIndex !== index) {
      this.toggleExpand(this.openIndex, false)
    }

    // handle menu at called index
    if (this.topLevelNodes[index]) {
      this.openIndex = expanded ? index : null
      this.topLevelNodes[index].setAttribute('aria-expanded', expanded)
      // add active if expanded
      if (expanded) {
        this.topLevelNodes[index].classList.add('active')
      } else {
        this.topLevelNodes[index].classList.remove('active')
      }
      this.toggleMenu(this.controlledNodes[index], expanded)
    }
  }

  toggleMenu(domNode, show) {
    // console.log('toggleMenu', domNode, show)
    if (domNode && show) {
      domNode.classList.add('open')
    } else if (domNode) {
      domNode.classList.remove('open')
    }
    // close all other menus
    // this.controlledNodes.forEach((menu, index) => {
    //   if (index !== this.openIndex && menu) {
    //     menu.classList.remove('active')
    //     this.topLevelNodes[index].setAttribute('aria-expanded', 'false')
    //   }
    // })
  }

  updateKeyControls(useArrowKeys) {
    this.useArrowKeys = useArrowKeys
  }
}

export default DisclosureNav
